import React from 'react';
import { Link } from 'react-router-dom';
import { FaInstagram, FaFacebook, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-warm text-secondary mt-auto">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12 mb-12">
          {/* About Section */}
          <div>
            <h3 className="text-2xl font-heading font-bold mb-5 text-secondary">
              Ky Tracy
            </h3>
            <p className="font-body text-text-secondary leading-relaxed text-base">
              Dedicated to capturing empowering and authentic portraits that reveal
              your unique essence and confidence.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-heading font-bold mb-5 text-secondary">
              Quick Links
            </h3>
            <ul className="space-y-3 font-body">
              <li>
                <Link
                  to="/about"
                  className="text-text-secondary hover:text-accent-secondary transition-all duration-300 inline-block hover:translate-x-1 text-base"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/portfolio"
                  className="text-text-secondary hover:text-accent-secondary transition-all duration-300 inline-block hover:translate-x-1 text-base"
                >
                  Portfolio
                </Link>
              </li>
              <li>
                <Link
                  to="/blog"
                  className="text-text-secondary hover:text-accent-secondary transition-all duration-300 inline-block hover:translate-x-1 text-base"
                >
                  Blog
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-text-secondary hover:text-accent-secondary transition-all duration-300 inline-block hover:translate-x-1 text-base"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Connect */}
          <div>
            <h3 className="text-2xl font-heading font-bold mb-5 text-secondary">
              Connect
            </h3>
            <p className="font-body text-text-secondary mb-4 text-base">
              Follow us on social media for the latest updates and behind-the-scenes content.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://instagram.com/kytracymedia"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-black/5 rounded-full flex items-center justify-center text-text-secondary hover:text-white hover:bg-accent transition-all duration-300 hover:scale-110"
                aria-label="Instagram"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://www.linkedin.com/in/ky-tracy-7675632a8"
                target="_blank"
                rel="noopener noreferrer"
                className="w-12 h-12 bg-black/5 rounded-full flex items-center justify-center text-text-secondary hover:text-white hover:bg-accent transition-all duration-300 hover:scale-110"
                aria-label="LinkedIn"
              >
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M16.338 16.338H13.67V12.16c0-.995-.017-2.277-1.387-2.277-1.39 0-1.601 1.086-1.601 2.207v4.248H8.014v-8.59h2.559v1.174h.037c.356-.675 1.227-1.387 2.526-1.387 2.703 0 3.203 1.778 3.203 4.092v4.711zM5.005 6.575a1.548 1.548 0 11-.003-3.096 1.548 1.548 0 01.003 3.096zm-1.337 9.763H6.34v-8.59H3.667v8.59zM17.668 1H2.328C1.595 1 1 1.581 1 2.298v15.403C1 18.418 1.595 19 2.328 19h15.34c.734 0 1.332-.582 1.332-1.299V2.298C19 1.581 18.402 1 17.668 1z" />
                </svg>
              </a>
              <a
                href="mailto:kytracy23@gmail.com"
                className="w-12 h-12 bg-black/5 rounded-full flex items-center justify-center text-text-secondary hover:text-white hover:bg-accent transition-all duration-300 hover:scale-110"
                aria-label="Email"
              >
                <FaEnvelope size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-black/10 pt-8 text-center font-body text-text-light text-sm">
          <p>&copy; {currentYear} Ky Tracy. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
